import { listDevice } from "../../list-device/redux/actions";
import { of, catchError, from } from "rxjs";
import { Epic, ofType } from "redux-observable";
import { RootState } from "../../../../redux/store";
import { SUBSCRIBE_DEVICE_REQUEST, subscribeDeviceSuccessAction, subscribeDeviceFailureAction, UNSUBSCRIBE_DEVICE_ACTION } from "./actions";
import { subscribeOnCreateDevice, unsubscribeOnCreateDevice } from "./service";
import { authenticatedClient } from "../../../../client/graphql";
import { mergeMap, switchMap, takeUntil, tap, ignoreElements } from "rxjs/operators";
import { Action } from "redux";

export const subscribeOnCreateDeviceEpic: Epic<Action, Action, RootState> = (action$) => {
    return action$.pipe(
        ofType(SUBSCRIBE_DEVICE_REQUEST),
        switchMap(() => {
            return from(subscribeOnCreateDevice(authenticatedClient)).pipe(
                takeUntil(action$.pipe(ofType(UNSUBSCRIBE_DEVICE_ACTION))),
                mergeMap((data) => [subscribeDeviceSuccessAction(data), listDevice()]),
                catchError((error) => of(subscribeDeviceFailureAction(error))),
            );
        }),
    );
};

export const unsubscribeOnCreateDeviceEpic: Epic<Action, Action, RootState> = (action$) =>
    action$.pipe(
        ofType(UNSUBSCRIBE_DEVICE_ACTION),
        tap(() => unsubscribeOnCreateDevice()),
        ignoreElements(),
    );

export default subscribeOnCreateDeviceEpic;